import { action, observable } from 'mobx'

export interface IWeekConsumptionStore {
  currentDayIndex: number
  WeekConsumption: IDayConsumption[]
  incrementCurrentDayIndex(): void
  setCurrentDayIndex(index: number): void
  addDayConsumption(dayConsumption: IDayConsumption): void
  getDayConsumption(dayIndex: number): IDayConsumption | null
  cleanWeekConsumption(dayList: number[]): void
  getGlassesNumberPerWeek(): number
  checkDayConsumptionForResults(): number
  reset(): void
}

export interface IDayConsumption {
  dayIndex: number
  beerCount: number
  wineCount: number
  strongAlcoolCount: number
  cocktailCount: number
}

export class ClassWeekConsumptionStore implements IWeekConsumptionStore {
  @observable public currentDayIndex = 0
  @observable public WeekConsumption = []

  @action public incrementCurrentDayIndex(): void {
    this.currentDayIndex++
  }

  @action public setCurrentDayIndex(index: number): void {
    this.currentDayIndex = index
  }

  @action public addDayConsumption(dayConsumption: IDayConsumption): void {
    const foundDayIndex = this.WeekConsumption.findIndex(
      (element: IDayConsumption) => element.dayIndex === dayConsumption.dayIndex
    )
    if (foundDayIndex === -1) {
      this.WeekConsumption.push(dayConsumption)
    } else {
      this.WeekConsumption[foundDayIndex] = dayConsumption
    }
  }

  @action public getDayConsumption(dayIndex: number): IDayConsumption | null {
    const dayConsumption = this.WeekConsumption.find(
      (element: IDayConsumption) => {
        return element.dayIndex === dayIndex
      }
    )
    return dayConsumption !== undefined ? dayConsumption : null
  }

  @action public cleanWeekConsumption(dayList: number[]): void {
    this.WeekConsumption = this.WeekConsumption.filter(
      (element: IDayConsumption) => {
        return dayList.includes(element.dayIndex)
      }
    )
  }

  @action public getGlassesNumberPerWeek(): number {
    const reducer = (accumulator: number, currentValue: IDayConsumption) =>
      accumulator +
      currentValue.beerCount +
      currentValue.wineCount +
      currentValue.strongAlcoolCount +
      currentValue.cocktailCount

    const nbGlasses = this.WeekConsumption.reduce(reducer, 0)
    return nbGlasses > 100 ? 100 : nbGlasses
  }

  @action public checkDayConsumptionForResults(): number {
    return this.WeekConsumption.every((dayConsumption: IDayConsumption) => {
      return (
        dayConsumption.beerCount +
          dayConsumption.wineCount +
          dayConsumption.cocktailCount +
          dayConsumption.strongAlcoolCount <=
        2
      )
    })
      ? 0
      : 1
  }

  @action public reset(): void {
    this.currentDayIndex = 0
    this.WeekConsumption = []
  }
}

export const WeekConsumptionStore = new ClassWeekConsumptionStore()



// WEBPACK FOOTER //
// ./src/store/WeekConsumptionStore.ts